import { SupportRequestStatusCategory } from "@/libraries/bxp-web-stargate-client/src";

const STATUS_CATEGORY_MAP: Record<string, SupportRequestStatusCategory> = {
    "atlassian investigating": SupportRequestStatusCategory.InProgress,
    "completed": SupportRequestStatusCategory.Done
};

export const getStatusCategory = (status?: string) => {
    if (!status) {
        return SupportRequestStatusCategory.Open;
    }
    const normalizedStatus = status.toLowerCase();
    return (
        STATUS_CATEGORY_MAP[normalizedStatus] ||
        SupportRequestStatusCategory.Open
    );
};
